import { render, staticRenderFns } from "./ModalAddProcessor.vue?vue&type=template&id=38ecfb84&scoped=true"
import script from "./ModalAddProcessor.vue?vue&type=script&lang=js"
export * from "./ModalAddProcessor.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProcessor.vue?vue&type=style&index=0&id=38ecfb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecfb84",
  null
  
)

export default component.exports